<template>
  <div class="wechat">
    <div class="main">
      <h5>爱艺术+客服微信</h5>
      <div class="code">
        <img
          :src="code"
          alt=""
        >
      </div>
      <div class="opation">
        <div class="btn" v-if="ua=='iartAndroid'||ua=='iartIos'" @click="save">
          保存二维码图片
        </div>
        <p v-if="ua=='iartAndroid'||ua=='iartIos'">保存二维码图片，微信扫码添加客服微信</p>
        <p v-else>长按识别二维码图片，微信扫码添加客服微信</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wechat",
  metaInfo: {
    title: "爱艺术+客服微信",
  },
  data() {
    return {
        ua:'',  //iartAndroid iartIos
        imgUrl:'',
        code:"https://mpicture.iartschool.com/20221028/1035492663211589632.jpeg"
    }
  },
  mounted() {
    let _this=this;
     this.ua =sessionStorage.getItem('ua');
    this.startTrans(
      _this.code,
      function (base64) {
        _this.imgUrl = base64;
      }
    );
  },
  methods: {
     getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var dataURL = canvas.toDataURL("image/png"); // 可选其他值 image/jpeg
      return dataURL;
    },
    startTrans(src, cb) {
      var _this = this;
      var image = new Image();
      image.src = src; // 处理缓存
      image.crossOrigin = "*"; // 支持跨域图片
      image.onload = function () {
        var base64 = _this.getBase64Image(image);
        cb && cb(base64);
      };
    },
    save() {
      let _this=this;
      if (typeof window.android != "undefined" || typeof window.IARTSCHOOL != "undefined") {
             if (typeof window.android != "undefined") {
              window.android.savePicture(JSON.stringify({ imgSource: _this.code }));
              } else if (typeof window.IARTSCHOOL != "undefined") {
                  window.IARTSCHOOL.saveImg({ base64:_this.imgUrl, });
              }
      } else {
        
      }
    }
  },

}
</script>

<style lang="scss" scoped>
.wechat {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(180deg, #fff6eb 0%, #fee6cd 100%);
  overflow: auto;
  .main {
    margin: 24px 12px;
    border-radius: 16px;
    background: #fff;
    text-align: center;
    padding-bottom: 80px;
    h5 {
      font-size: 20px;
      line-height: 28px;
      color: rgba(45, 45, 45, 1);
      font-weight: 600;
      padding: 28px 0;
    }
    .code {
      border-top: 1px dashed rgba(254, 229, 205, 1);
      padding-top: 34px;
      img {
        display: inline-block;
        width: 230px;
        height: 230px;
        margin: 0 auto;
      }
    }
    .opation {
      margin-top: 35px;
      .btn {
        font-size: 16px;
        line-height: 22px;
        color: rgba(255, 227, 205, 1);
        border-radius: 26px;
        overflow: hidden;
        padding: 15px 0;
        text-align: center;
        font-weight: 600;
        margin: 24px 12px 0;
        border-radius: 26px;
        background: linear-gradient(156deg, #e94c43 0%, #d4352c 100%);
      }
      p {
        margin-top: 16px;
        font-size: 12px;
        line-height: 18px;
        color: rgba(71, 62, 62, 1);
        font-weight: 400;
      }
    }
  }
}
</style>